<template>
    <v-list v-if="items && items.length" class="pa-0 transparent">
        <template v-for="(item, i) in items">
            <v-list-item
                v-if="item.type === 'exam'"
                v-haptic
                :key="item.item.id + '-' + i"
                :disabled="item.locked"
                v-ripple="phoneOnly"
                class="px-7 py-1"
                :link="phoneOnly"
            >
                <v-list-item-icon @click="phoneOnly && !item.locked ? $emit('open-exam', item.item) : undefined">
                    <v-icon :color="item.item.needs_attention ? 'error' : 'primary'">mdi-clipboard-text-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content @click="phoneOnly && !item.locked ? $emit('open-exam', item.item) : undefined">
                    <v-list-item-title>
                        {{ item.item.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text--text d-flex details-text">
                        <div v-if="item.item.must_pass" class="d-flex">
                            <v-icon :color="item.item.needs_attention ? 'error' : 'success darken-1'" size="16" class="me-1">mdi-{{ item.item.needs_attention ? 'license' : 'check' }}</v-icon>
                            <span :class="{ 'font-weight-bold': item.item.needs_attention }">النجاح مطلوب</span>
                        </div>
                        <div v-else-if="item.item.must_take" class="d-flex">
                            <v-icon :color="item.item.needs_attention ? 'error' : 'strong-text'" size="16" class="me-1">mdi-{{ item.item.needs_attention ? 'login' : 'check' }}</v-icon>
                            <span>دخول الامتحان مطلوب</span>
                        </div>

                        <div v-if="item.item.navigate_to_alternative && item.item.alternative_exam" class="d-flex ms-2">
                            <v-icon color="primary" size="16" class="me-1">mdi-reload</v-icon>
                            <span>تجربة مع امتحان آخر</span>
                        </div>
                        <div v-else-if="item.item.questions_count || item.item.questions_count === 0" class="d-flex ms-2">
                            <v-icon color="primary" size="16" class="me-1">mdi-file-question-outline</v-icon>
                            <span>{{ unitFormat(item.item.questions_count, 'سؤال', 'سؤالين', 'أسئلة') }}</span>
                        </div>
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon class="ms-0">
                    <v-icon v-if="item.locked" color="muted">mdi-lock</v-icon>

                    <v-btn
                        v-else-if="pcOnly"
                        :disabled="openingExam"
                        :color="item.item.navigate_to_alternative ? (item.item.needs_attention ? 'red darken-1' : 'success darken-1') : 'primary'"
                        dark
                        :outlined="!item.item.needs_attention"
                        @click.stop.prevent="$emit('open-exam', item.item)"
                    >
                        {{ item.item.navigate_to_alternative ? 'الامتحان البديل' : 'فتح الامتحان' }}
                        <v-icon right>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-icon v-else>mdi-arrow-left</v-icon>
                </v-list-item-icon>
            </v-list-item>
            <v-list-item
                v-else-if="item.type === 'video'"
                v-haptic
                :key="item.item.id + '-' + i"
                :disabled="item.locked || !item.item.viewable"
                @click="!item.locked ? $emit('play-video', item.item, i) : undefined"
                v-ripple="phoneOnly"
                class="px-7 py-1"
            >
                <v-list-item-icon>
                    <v-icon :color="item.item.viewable ? (item.item.views_limit - item.item.counted_views === 1 ? 'error' : (!item.locked && item.item.seen ? 'success' : 'primary')) : ''">{{ !item.locked && item.item.seen ? 'mdi-check-circle' : 'mdi-play-box' }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ item.item.name }}

                        <template v-if="attendanceChipPlacement === 'title' && !item.item.hide_attendance_chips">
                            <v-chip v-if="item.item.attendance_required" label x-small class="strong-text--text px-1 ms-1" color="grey lighten-2"><b class="me-1">*</b>{{ item.item.attendance_chip_text || 'أساسي' }}</v-chip>
                        </template>
                    </v-list-item-title>
                    <v-list-item-subtitle class="d-flex align-center" :class="{ 'details-text': pcOnly, 'x-small-text': phoneOnly }">
                        <template v-if="attendanceChipPlacement === 'subtitle' && !item.item.hide_attendance_chips">
                            <v-chip v-if="item.item.attendance_required" label x-small class="strong-text--text px-1 me-2" color="grey lighten-2"><b class="me-1">*</b>{{ item.item.attendance_chip_text || 'أساسي' }}</v-chip>
                        </template>
                        <div v-if="!lecture.expired" class="text--text me-2" style="line-height: 1.3!important;">
                            <span v-if="item.locked" class="muted--text">لا يمكنك مشاهدة الفيديو</span>
                            <span v-else-if="item.item.views_limit" :class="{ 'green--text text--darken-2': item.item.counted_views === 0, 'error--text': item.item.views_limit - item.item.counted_views === 1 }">
                                تبقى <b>{{ item.item.views_limit - item.item.counted_views > 0 ? item.item.views_limit - item.item.counted_views : 0 }}</b>
                                من
                                {{ unitFormat(item.item.views_limit, 'مشاهدة', 'مشاهدتين', 'مشاهدات') }}
                            </span>
                            <span v-else>لا يوجد حد للمشاهدات</span>
                        </div>
                        <div style="line-height: 1.3!important;">
                            <span v-if="lecture.expired" class="error--text">
                                <v-icon color="error" small class="me-1">mdi-alert-outline</v-icon>
                                المحاضرة منتهية الصلاحية
                            </span>
                            <span v-else-if="lecture.expiry_days" class="orange--text text--darken-2">صالحة لمدة <b>{{ unitFormat(lecture.expiry_days, 'يوم', 'يومين', 'أيام') }}</b></span>
                        </div>
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-icon v-if="item.locked" color="muted">mdi-lock</v-icon>
                    <v-icon v-else-if="item.item.viewable" color="primary" style="transform: rotate(270deg)">mdi-open-in-new</v-icon>
                    <v-icon v-else color="warning">mdi-progress-alert</v-icon>
                </v-list-item-icon>
            </v-list-item>
            <v-divider v-if="i < items.length - 1" :key="'d-' + i" style="border-color: rgba(0,0,0, 0.08)"></v-divider>
        </template>

        <template v-if="!hideAttachments">
            <v-divider key="divider" style="border-color: rgba(0,0,0, 0.08)"></v-divider>

            <template v-for="(attachment, i) in attachmentsList">
            <v-list-item v-haptic :key="attachment.id" :href="attachment.url" download class="px-7 py-1">
                <v-list-item-icon>
                    <v-icon color="strong-text">mdi-paperclip</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ attachment.name }}</v-list-item-title>
                    <v-list-item-subtitle>
                        <v-chip dark :color="attachment.meta.extension === 'pdf' ? 'deep-orange' : 'primary'" label small class="me-1">
                            <v-icon class="me-1">mdi-file</v-icon>
                            {{ attachment.meta.extension.toUpperCase() }}
                        </v-chip>
                        <v-chip label small class="ltr-dir">
                            {{ attachment.size }}
                        </v-chip>
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-btn as="a" icon large color="secondary" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop :href="attachment.url">
                        <v-icon size="22">mdi-download</v-icon>
                    </v-btn>
                </v-list-item-icon>
            </v-list-item>

            <v-divider v-if="i < attachmentsList.length - 1" :key="'d' + i" style="border-color: rgba(0,0,0, 0.08)"></v-divider>
            </template>
        </template>
    </v-list>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: 'LectureContentsList',
    props: {
        items: {
            type: Array,
            default: null,
        },
        attachments: {
            type: Array,
            default: () => [],
        },
        lecture: {
            type: Object,
            required: true,
        },
        openingExam: {
            type: Boolean,
            default: false,
        },
        /** 'title' matches lecture-dialog; 'subtitle' matches Lecture.vue page */
        attendanceChipPlacement: {
            type: String,
            default: 'title',
            validator: (v) => v === 'title' || v === 'subtitle',
        },
        hideAttachments: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...GlobalComputed,
        attachmentsList() {
            return this.attachments && this.attachments.length ? this.attachments : []
        },
    },
    methods: {
        ...GlobalMethods,
    },
}
</script>
